export const generalProperties = [
    {
        "label":"Nombre",
        "key": "name"
    }
]